import { Component, inject } from '@angular/core';
import { GroupedModules, Module } from 'src/app/models/auth';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html'
})
export class SideNavComponent {
  private readonly authService = inject(AuthService);

  authUserData$ = this.authService.authUserData$;
  groupedModules$ = this.authService.availableModulesGroups$;

  navExpanded = false;
  expandMore = false;

  toggleExpandNav() {
    this.navExpanded = !this.navExpanded;
  }

  toggleExpandMore() {
    this.expandMore = !this.expandMore;
  }

  logOut() {
    this.authService.logOut();
  }

  setModuleActive(grouping: GroupedModules, module: Module) {
    this.navExpanded = false;
    this.authService.setActiveModule(grouping, module);
  }
}
